/**
 * CardPreviews Component
 *
 * Shows how submitted content will appear in collection rails:
 * - Horizontal card preview (16:9 landscape)
 * - Vertical card preview (2:3 portrait)
 *
 * Features:
 * - Center card shows real submission data
 * - Placeholder cards provide context
 * - Gradient shadows focus attention on center card
 * - Hover effects enabled on preview cards
 */

import type { ReactElement } from "react";
import { PreviewRail } from "./PreviewRail";
import type { TitlePreviewData } from "./TitlePreview";

interface CardPreviewsProps {
  readonly data: TitlePreviewData;
  readonly submissionId?: string | null;
  readonly titleId?: string | null;
}

export function CardPreviews({ data, submissionId, titleId }: CardPreviewsProps): ReactElement {
  return (
    <div className="space-y-0">
      {/* Horizontal Card Preview */}
      <PreviewRail
        title=""
        description=""
        cardType="HORIZONTAL"
        previewData={data}
        submissionId={submissionId}
        titleId={titleId}
      />

      {/* Vertical Card Preview */}
      <PreviewRail
        title=""
        description=""
        cardType="VERTICAL"
        previewData={data}
        submissionId={submissionId}
        titleId={titleId}
      />
    </div>
  );
}
